import classNames from 'classnames';

import styles from '../../../styles/icons/bar-indicator-icon.module.css';

interface BarIndicatorIconProps {
    answered: boolean;
    valid: boolean;
    className: string;
}

function BarIndicatorIcon({ valid, answered, className = null }: BarIndicatorIconProps) {
    return (
        <span
            className={classNames([
                styles.container,
                { [styles.answered]: answered, [styles.valid]: valid },
                className,
            ])}
        />
    );
}

export default BarIndicatorIcon;
